import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Spinner, Alert } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import axiosInstance from '../../api/axios';

function Register() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [country, setCountry] = useState('Venezuela');
  const [agree, setAgree] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!agree) {
      setError(t('agree_terms_required', 'Debes aceptar los Términos y Condiciones para registrarte.'));
      return;
    }
    setError('');
    setLoading(true);

    try {
      const response = await axiosInstance.post('/auth/register', {
        nombre_completo: username,
        email,
        password,
        rol: 'Cliente', // Default role for auto-registered users
        status: 'activo',
        requires_password_change: false,
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/user-pages/login');
        }, 2000);
      } else {
        setError(response.data.message || t('error', 'Error en el registro.'));
      }
    } catch (err) {
      setError(err.response?.data?.message || t('server_connection_error', 'Error de conexión con el servidor.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex align-items-stretch auth auth-img-bg h-100">
        <div className="row flex-grow w-100 mx-0">
          <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
            <div className="auth-form-transparent text-start p-4 p-sm-5" style={{ maxWidth: '450px', width: '100%' }}>
              <div className="brand-logo mb-4">
                <img src="/images/logo.svg" alt="logo" style={{ width: '150px' }} />
              </div>
              <h4>{t('new_here')}</h4>
              <h6 className="fw-light mb-4">{t('join_us_today')}</h6>

              {error && <Alert variant="danger" className="mb-3">{error}</Alert>}
              {success && <Alert variant="success" className="mb-3">{t('register_success_redirect', '¡Registro exitoso! Redirigiendo al login...')}</Alert>}

              <Form onSubmit={handleRegister}>
                <div className="form-group mb-3">
                  <label className="text-muted small fw-bold mb-1">{t('username')}</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0">
                        <i className="mdi mdi-account-outline text-primary"></i>
                      </span>
                    </div>
                    <input 
                      type="text" 
                      className="form-control form-control-lg border-left-0" 
                      placeholder={t('username')} 
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label className="text-muted small fw-bold mb-1">{t('email')}</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0">
                        <i className="mdi mdi-email-outline text-primary"></i>
                      </span>
                    </div>
                    <input 
                      type="email" 
                      className="form-control form-control-lg border-left-0" 
                      placeholder={t('email')} 
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group mb-3">
                  <label className="text-muted small fw-bold mb-1">{t('country')}</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0">
                        <i className="mdi mdi-earth text-primary"></i>
                      </span>
                    </div>
                    <select 
                      className="form-select form-select-lg border-left-0"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    >
                      <option value="Venezuela">Venezuela</option>
                      <option value="Colombia">Colombia</option>
                      <option value="Argentina">Argentina</option>
                      <option value="Mexico">México</option>
                      <option value="USA">United States</option>
                    </select>
                  </div>
                </div>

                <div className="form-group mb-4">
                  <label className="text-muted small fw-bold mb-1">{t('password')}</label>
                  <div className="input-group">
                    <div className="input-group-prepend bg-transparent">
                      <span className="input-group-text bg-transparent border-right-0">
                        <i className="mdi mdi-lock-outline text-primary"></i>
                      </span>
                    </div>
                    <input 
                      type="password" 
                      className="form-control form-control-lg border-left-0" 
                      placeholder={t('password')} 
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="mb-4">
                  <div className="form-check">
                    <label className="form-check-label text-muted">
                      <input 
                        type="checkbox" 
                        className="form-check-input" 
                        checked={agree}
                        onChange={(e) => setAgree(e.target.checked)}
                      />
                      <i className="input-helper"></i>
                      {t('agree_terms')}
                    </label>
                  </div>
                </div>

                <div className="mt-3 d-grid gap-2">
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-lg fw-medium auth-form-btn py-3" 
                    disabled={loading}
                    style={{ borderRadius: '8px' }}
                  >
                    {loading ? <Spinner animation="border" size="sm" /> : t('sign_up')}
                  </button>
                </div>

                <div className="text-center mt-4 fw-light small">
                  {t('already_have_account')} <Link to="/user-pages/login" className="text-primary fw-bold">{t('login_btn')}</Link>
                </div>
              </Form>
            </div>
          </div>
          <div className="col-lg-6 register-half-bg d-none d-lg-flex flex-row">
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;
